module.exports = __webpack_public_path__ + "static/media/people-3.f202114c.svg";